/* Prestige sliders: mobile one-per-view slider, and hover-arrow rails */
(function () {
  'use strict';
  if (window.__pxSliderLoaded) return;
  window.__pxSliderLoaded = true;

  var mq = window.matchMedia('(max-width: 749px)');

  function slideWidth(track) {
    var first = track.firstElementChild;
    if (!first) return track.clientWidth;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  /* Put the arrows at the true vertical centre of the card image.
     A fixed percentage of the whole slider misses, because the title and
     price below the image change the total height. */
  function centreArrows(root, track) {
    var first = track.firstElementChild;
    if (!first) return;
    var media = first.querySelector('.px-card__media, figure, .px-ratio, .px-media');
    if (!media) return;
    var h = media.getBoundingClientRect().height;
    if (h > 0) root.style.setProperty('--rail-arrow-top', Math.round(h / 2) + 'px');
  }

  /* ---------- one item per view (or peeking) on mobile ---------- */
  function build(root) {
    var track = root.querySelector('.px-slider__track');
    var dots = root.querySelector('[data-px-dots]');
    var prev = root.querySelector('[data-px-prev]');
    var next = root.querySelector('[data-px-next]');
    if (!track) return;
    var slides = track.children;
    if (slides.length < 2) return;

    if (dots && !dots.children.length) {
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'on';
        dots.appendChild(d);
      }
    }

    function index() { return Math.round(track.scrollLeft / slideWidth(track)); }

    function sync() {
      var i = index();
      var max = track.scrollWidth - track.clientWidth;
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) {
        d.classList.toggle('on', k === i);
      });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      root.classList.toggle('is-start', track.scrollLeft <= 2);
      root.classList.toggle('is-end', track.scrollLeft >= max - 2);
    }

    function go(dir) {
      track.scrollTo({ left: (index() + dir) * slideWidth(track), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    function refresh() { centreArrows(root, track); sync(); }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 90); });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    refresh();
  }

  /* ---------- hover arrows over a horizontal carousel ---------- */
  function buildRail(root) {
    var track = root.querySelector('[data-px-rail-track]');
    var prev = root.querySelector('[data-px-rail-prev]');
    var next = root.querySelector('[data-px-rail-next]');
    if (!track) return;

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-start', track.scrollLeft <= 2);
      root.classList.toggle('is-end', track.scrollLeft >= max - 2);
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(track), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(track), behavior: 'smooth' });
    });

    function refresh() { centreArrows(root, track); sync(); }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 70); });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    refresh();
  }

  function apply() {
    document.querySelectorAll('[data-px-rail]').forEach(function (root) {
      if (root.dataset.pxRailInit) return;
      root.dataset.pxRailInit = '1';
      buildRail(root);
    });

    document.querySelectorAll('[data-px-slider]').forEach(function (root) {
      root.classList.toggle('px-slider--on', mq.matches);
      if (mq.matches && !root.dataset.pxSliderInit) {
        root.dataset.pxSliderInit = '1';
        build(root);
      }
    });
  }

  /* Exposed so sections whose markup arrives after page load can initialise
     their own rails. px-related is the case that needs it: its cards come from
     a fetch to the recommendations API, so at DOMContentLoaded there is no rail
     in the DOM yet. Without a second call the arrows never get their
     is-start/is-end state and sit visible over a row that cannot scroll.
     apply() is idempotent — the data-px-rail-init flag stops double binding. */
  window.pxSliderApply = apply;

  document.addEventListener('DOMContentLoaded', apply);
  if (mq.addEventListener) { mq.addEventListener('change', apply); } else { mq.addListener(apply); }
  document.addEventListener('shopify:section:load', apply);
  apply();
})();
